import React from "react";
import { Typography, Stack } from "@mui/material";
import spilledPopcorn from "../../../images/png/spilledPopcorn.png";

const NoMovies = () => (
  <Stack
    alignItems="center"
    justifyContent="center"
    sx={{ minHeight: "60vh", px: 2 }}
  >
    <img
      src={spilledPopcorn}
      alt="Spilled Popcorn"
      style={{ width: 240, height: 240 }}
    />
    <Typography variant="h4" sx={{ mt: 2, textAlign: "center" }}>
      Hmm...No Movies right now check again in a while
    </Typography>
  </Stack>
);

export default NoMovies;
